import { Outlet } from '@tanstack/react-router'
import { Header } from '../../common'
import { AppSidebar, HelpAndFeedbackButton } from '@molecules'
import { ToastContainer } from '../../common/Alert/ToastContainer/ToastContainer'
import { GlobalDrawer, GlobalModal } from '@organisms'
import NavigationGuard from '@/utils/NavigationGuard'

const PageLayout: React.FC = () => {
    return (
        <>
            <NavigationGuard />
            <div className="relative h-full overflow-hidden">
                <div className="grid h-full grid-cols-[auto_1fr]">
                    <div className="border-r border-neutral-200">
                        <AppSidebar />
                    </div>
                    <main className="relative z-10 grid grid-rows-[auto_1fr] overflow-hidden">
                        <div className="relative z-[2000] border-b border-b-neutral-200 bg-white">
                            <Header />
                        </div>
                        <div className="overflow-auto pt-6">
                            <div className="relative z-50 mx-6">
                                <ToastContainer />
                            </div>
                            <Outlet />
                        </div>
                    </main>
                    <HelpAndFeedbackButton />
                </div>
                <GlobalDrawer />
                <GlobalModal />
            </div>
        </>
    )
}

export default PageLayout
